"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function PageHeader(props) {
    return React.createElement("header", { id: props.id, className: "l-site-header", style: props.style }, props.children);
}
exports.PageHeader = PageHeader;
